<template>
    <div>
        <input-group icon="fa fa-calendar">
            <input ref="picker-element"
                   class="form-control"
                   type="text"
                   
                   :disabled="disabled"
                   :readonly="!isReady"
                   
                   @click="preventIfNotReady($event)"
            />
        </input-group>
    </div>
</template>

<script>
import $ from 'jquery';
import {guid} from "@core/Util/guid";

import InputGroup from "@core/Components/Inputs/InputGroup";
import {mapState, mapMutations, mapActions} from "vuex";

export default {
    name: "PeriodPicker",
    
    components: {
        InputGroup
    },
    
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    
    computed: {
        ...mapState('journeyBuilder/reporting', [ 'periodStart', 'periodEnd' ]),
        
        isReady() {
            //periodStart and periodEnd are always set in conjunction with eachother
            return !!this.periodStart;
        }
    },

    async mounted() {
        await this.loadDefaultPeriodRange();
        
        //Allow our computed values to update
        await this.$nextTick();
        
        const pickerElement = this.$refs['picker-element'];

        //Move our container id to our element so our parent can assign a label to us
        if(this.$el.id){
            pickerElement.id = this.$el.id;
        }

        //A container selector is required by our datepicker plugin for proper positioning upon opening
        const elementId = `period-picker-wrapper-${guid()}`;
        this.$el.id = elementId;
        
        $(pickerElement).mdbDatepicker({
            //Convert values to datepicker format
            dateStart: moment(this.periodStart, 'YYYY-MM-DD').format('DD-MM-YYYY'), 
            dateEnd: moment(this.periodEnd, 'YYYY-MM-DD').format('DD-MM-YYYY'),
            
            //When any value but an empty string is provided, the datepicker will override our dateStart/dateEnd values
            sessionStartDate: '',
            sessionEndDate: '',
            
            parent: `#${elementId}`,
            disableClear: true,
            callback: (start, end) => {
                //Convert values to MVC known format
                this.setPeriodStart(moment(start, 'DD-MM-YYYY').format('YYYY-MM-DD'));
                this.setPeriodEnd(moment(end, 'DD-MM-YYYY').format('YYYY-MM-DD'));
            }
        });
    },
    
    methods: {
        ...mapMutations('journeyBuilder/reporting', [ 'setPeriodStart', 'setPeriodEnd' ]),
        ...mapActions('journeyBuilder/reporting', [ 'loadDefaultPeriodRange' ]),
        
        preventIfNotReady(event) {
            if(!this.isReady) {
                event.preventDefault();
                event.stopImmediatePropagation();
            }
        }
    }
}
</script>
